import React, { useEffect, useMemo, useRef } from 'react';
import cn from 'clsx';
import { RegularButton, RegularButtonProps, RegularButtonVariant } from 'fronton-react';
import { useHrefConverter } from '../../hooks/use-href-converter';
import { adaptiveSizeStylesMap } from './button-styles';
import { AdaptiveSize } from './button-types';

export type ButtonProps = {
  adaptive?: boolean;
  className?: string;
  variant?: RegularButtonVariant;
  invert?: boolean; 
} & RegularButtonProps;

export const Button = ({
  adaptive = true,
  children,
  className,
  href,
  rel,
  size = 'l',
  ...props
}: ButtonProps) => {
  const ref = useRef<HTMLButtonElement>(null);
  const buttonHref = useHrefConverter(href);
  const classNames = useMemo(
    () =>
      cn(className, {
        [adaptiveSizeStylesMap[size as AdaptiveSize]]: adaptive,
      }),
    [adaptive, className, size]
  );

  /**
   * Удаляем параметр rel со значением по умолчанию "noopener noreferrer", если параметр rel не передан
   */
  useEffect(() => {
    if (!rel && href) {
      ref.current?.removeAttribute('rel');
    }
  }, [rel, href]);

  return (
    <RegularButton
      href={buttonHref}
      ref={ref}
      rel={rel}
      className={classNames}
      {...(props as RegularButtonProps)}
      size={size}>
      {children}
    </RegularButton>
  );
};

Button.defaultProps = {
  adaptive: true,
  className: undefined,
};
